<template>
  <div class="section section-2 py-md-5" id="vacunados-region-edad">
    <div class="container">
      <h2 class="text-center section__title-principal mb-3">
        Vacunados por región y por tramo de edad
      </h2>
      <div class="row">
        <div class="col">
          <div class="section__box-select--medium">
            <multiselect
              v-model="selectedRegion"
              track-by="value"
              label="text"
              placeholder="Seleccione una dosis"
              :options="regiones"
              @input="changeRegion($event)"
              selected="text"
              selectLabel="Presione enter para seleccionar"
              selectedLabel="Seleccionado"
              :searchable="false"
              :allow-empty="false"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.text }}</strong></template
              >
            </multiselect>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="chart-bar">
          <canvas ref="chart"></canvas>
        </div>
        <div class="col-12 d-flex justify-content-start justify-content-md-end py-1">
          <p class="mb-0 text-fuente">
            <b>Fuente:</b> Minsal y estimaciones 2021 del INE
            (DEIS)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chartDefaults } from '@/charts'
import { getPorcentajeInmunizados, getRegiones } from "@/api";
import { getRegionByDiario } from "../../api/regionbydiario";
export default {
  data() {
    return {
      chart: null,
      porcentajeInmunizados: [],
      regiones: [],
      valueId: '',
      selectedRegion: {},
      datos: [],
    }
  },

  methods: {
    async createChart() {
      if (this.chart) {
        this.chart.destroy()
      }

      let findDataRegion = this.datos.find((element) => element[0] === this.selectedRegion.text)

      this.chart = new this.$chart(this.$refs.chart, {
        type: "bar",
        data: {
          labels: Object.keys(findDataRegion[1]),
          datasets: [
            {
              label: `${findDataRegion[0]}`,
              backgroundColor: '#FFBA4E',
              data: Object.values(findDataRegion[1]),
            }
          ]
        },
      options: chartDefaults.barHorizontalRegiones
      })
    },

    getZonaById() {
      return this.regiones.find((element) => element.value === this.valueId)
    },

    async changeRegion(selectedOption) {
      // se cambia la dosis seleccionada y se reescribe el grafico
      this.selectedRegion = selectedOption
      this.createChart()
    }
  },

  async mounted() {
    let id = window.app.idDiario;
    this.valueId = getRegionByDiario(id)
    this.regiones = await getRegiones()
    this.selectedRegion = this.getZonaById()

    this.porcentajeInmunizados = await getPorcentajeInmunizados()
    for (let [key, value] of Object.entries(this.porcentajeInmunizados.data)) {
      this.datos.push([key, value])
    }

    this.createChart()
  }
}
</script>
